import { render } from "./Portefeuille.vue?vue&type=template&id=8d4f993a"
import script from "./Portefeuille.vue?vue&type=script&lang=js"
export * from "./Portefeuille.vue?vue&type=script&lang=js"

import "./Portefeuille.vue?vue&type=style&index=0&id=8d4f993a&media=screen&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__